__turbopack_context__.v({
  "contents": "TextBox-module__PZR-6q__contents",
  "line": "TextBox-module__PZR-6q__line",
  "lineno": "TextBox-module__PZR-6q__lineno",
  "linetrailing": "TextBox-module__PZR-6q__linetrailing",
  "selection": "TextBox-module__PZR-6q__selection",
});
